@for (level of levels; track level; let i = $index) {
  <div
    class="ui-level-indicator__step"
    [class.ui-level-indicator__step--active]="active && level.sequence <= active?.sequence"
    [style.--height]="(100 / levels.length) * (i + 1) + '%'"
  ></div>
}
@if (showLabel && active) {
  <div class="ui-level-indicator__label ui-caption">{{ active.name }}</div>
}
